import React, { useState } from "react";
import Button from "../../Button/Button";
import Modal from "../../Modal/Modal";
import "../AddSectionModal/AddSectionModal.css";

const AddSubParameterModal = ({
  onClose,
  onAdd,
  sectionName,
}) => {
  const [parameter, setParameter] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!parameter.trim()) {
      setError("Parameter name cannot be empty");
      return;
    }
    onAdd(parameter.trim(), []);
  };

  const footer = (
    <>
      <Button variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="primary" onClick={handleSubmit}>
        Add Parameter
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={`Adding New Sub Parameter Preset (${sectionName || "Critical to Customer"})`}
      maxWidth="480px"
      footer={footer}
    >
      <div className="section-modal-form-group">
        <label className="section-modal-label">
          Parameter Name
        </label>
        <input
          type="text"
          className="form-control"
          value={parameter}
          onChange={(e) => {
            setParameter(e.target.value);
            if (error) setError("");
          }}
          placeholder="Enter parameter name"
        />
        {error && <p className="section-modal-error">{error}</p>}
      </div>
    </Modal>
  );
};

export default AddSubParameterModal;


